import { BP } from './_constants';

export default {
    minMobile: `only screen and (min-width: ${BP.xsMin}px)`,
    minTablet: `only screen and (min-width: ${BP.smMin}px)`,
    minDesktop: `only screen and (min-width: ${BP.mdMin}px)`,
    minDesktopLG: `only screen and (min-width: ${BP.lgMin}px)`,

    maxMobile: `only screen and (max-width: ${BP.xsMax}px)`,
    maxTablet: `only screen and (max-width: ${BP.smMax}px)`,
    maxDesktop: `only screen and (max-width: ${BP.mdMax}px)`,
    maxDesktopLG: `only screen and (max-width: ${BP.lgMax}px)`,
};



// WEBPACK FOOTER //
// ./src/styles/breakpoints.js